import { render } from "./ModalCambiarPlan.vue?vue&type=template&id=15a07fdd&scoped=true"
import script from "./ModalCambiarPlan.vue?vue&type=script&lang=js"
export * from "./ModalCambiarPlan.vue?vue&type=script&lang=js"

import "./ModalCambiarPlan.vue?vue&type=style&index=0&id=15a07fdd&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a07fdd"]])

export default __exports__